import { isUndefined } from "lodash";

export const getDisplayName = component => {
  if (isUndefined(component)) {
    return "Styled";
  }
  return typeof component === "string"
    ? component
    : component.displayName || component.name || "Styled";
};
